export type TrackingProvider = 'ga4' | 'googleAds';

interface EventMapItem {
  providers: TrackingProvider[];
  ga4Event?: string;
  googleAdsEvent?: string;
  adsSendTo?: string;
}

export const EventMap: Record<string, EventMapItem> = {
  // ads 指标
  // 对话 结束
  ai_conversion_done: {
    providers: ['googleAds', 'ga4'],
    ga4Event: 'ai_conversion_done',
    googleAdsEvent: ' conversion',
    adsSendTo: 'AW-17666667935/qP3vCInkmbUbEJ_rj-hB',
  },

  // 注册-成功
  signup_success: {
    providers: ['ga4', 'googleAds'],
    ga4Event: 'sign_up',
    googleAdsEvent: 'conversion',
    adsSendTo: 'AW-17666667935/_-92CN28o7UbEJ_rj-hB',
  },

  // 支付成功
  purchase_success: {
    providers: ['ga4', 'googleAds'],
    ga4Event: 'purchase_success',
    googleAdsEvent: 'conversion',
    adsSendTo: 'AW-17666667935/2Jz7CKzKmLUbEJ_rj-hB',
  },

  // GA4
  // 登录-点击
  signin_click: {
    providers: ['ga4'],
    ga4Event: 'signin_click',
  },

  // 登录-失败
  signin_error: {
    providers: ['ga4'],
    ga4Event: 'signin_error',
  },

  // 登录-成功
  login_success: {
    providers: ['ga4'],
    ga4Event: 'login_success',
  },

  // 购买-进入
  purchase_loaded: {
    providers: ['ga4'],
    ga4Event: 'purchase_loaded',
  },

  // 购买-点击
  purchase_click: {
    providers: ['ga4'],
    ga4Event: 'purchase_click',
  },

  // 购买-失败
  purchase_fail: {
    providers: ['ga4'],
    ga4Event: 'purchase_fail',
  },
} as const;

// 动态生成 eventKeyMap
export const EventKeyMap = Object.keys(EventMap).reduce(
  (acc, key) => {
    acc[key] = key;
    return acc;
  },
  {} as Record<string, string>
);
